import Stack from '@mui/material/Stack'
import { ReactNode, useContext, useEffect, useState } from 'react'
import { ExternalPlatformMessage, ExternalPlatformMessagePayload, PlatformTemplate, PlatformType } from '../../../interfaces/IExternalCommunication'
import ExternalCommunication from './ExternalCommunication'
// eslint-disable-next-line import/no-unresolved
import EbIconLogo from '../../../assets/logos/eidsiva-icon.svg?react'
// eslint-disable-next-line import/no-unresolved
import EbIconLogoWhite from '../../../assets/logos/eidsiva-icon-white.svg?react'
import { Typography } from '@mui/material'
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework'
import { EventDto } from '../../../interfaces/IEvent'
import { enqueueSnackbar } from 'notistack'

export interface PlatformMessageProps {
  platformType: number
  headerText: ReactNode
  icon: ReactNode
  iconWhite?: ReactNode
  platformMessage: ExternalPlatformMessage
  messageIsExternallyVisible?: boolean
}

interface ExternalCommunicationContainerProps {
  viewEvent: EventDto
  onUpdateEventView: (eventId: string) => void
}

export default function ExternalCommunicationContainer({ viewEvent, onUpdateEventView }: ExternalCommunicationContainerProps) {
  const { context } = useContext(EbAuthenticatedAppContext)
  const [platformTemplates, setPlatformTemplates] = useState<PlatformTemplate[]>([])

  const [messagesProps, setMessagesProps] = useState<PlatformMessageProps[]>([
    {
      platformType: PlatformType.CompanyPages,
      headerText: `Ekstern melding - Min virksomhet`,
      icon: <EbIconLogo />,
      iconWhite: <EbIconLogoWhite />,
      platformMessage:
        viewEvent.externalPlatformMessages.find((message) => message.template.platformType === PlatformType.CompanyPages) ||
        ({} as ExternalPlatformMessage),
      messageIsExternallyVisible:
        viewEvent.externalPlatformMessages.find((m) => m.template.platformType === PlatformType.CompanyPages)?.isVisible ?? false,
    },
    // {
    //     platformType: PlatformType.EidsivaNo,
    //     headerText: `Ekstern melding - Eidsiva.no`,
    //     icon: <EbLogo />,
    //     iconWhite: <EbLogoWhite />,
    //     platformMessage: viewEvent.externalPlatformMessages.find((message) =>
    //         message.template.platformType === PlatformType.EidsivaNo) || {} as ExternalPlatformMessage,
    //     messageIsExternallyVisible: viewEvent.externalPlatformMessages.find((m) =>
    //         m.template.platformType === PlatformType.EidsivaNo)?.isVisible ?? false
    // }
  ])

  const getPlatformTemplates = async () => {
    var platformTemplates = await context.restApiClient
      .buildRequest(`/api/platform-templates`)
      .deserializeResponseToJson<PlatformTemplate[]>()
      .getAsync()

    if (platformTemplates?.json) {
      return setPlatformTemplates(platformTemplates.json)
    }

    if (platformTemplates.error) {
      enqueueSnackbar(<Typography variant="body2">Klarte ikke hente maler. Prøv igjen eller kontakt systemansvarlig.</Typography>, {
        variant: 'error',
      })
    }
  }

  useEffect(() => {
    getPlatformTemplates()
  }, [])

  const handleSubmit = async (platformMessage: ExternalPlatformMessagePayload) => {
    var response = await context.restApiClient
      .buildRequest(`/api/event/${viewEvent.id}/externalMessage`)
      .serializeToJsonContent(platformMessage)
      .putAsync()

    if (response.error) {
      enqueueSnackbar(<Typography variant="body2">Klarte ikke lagre melding. Prøv igjen eller kontakt systemansvarlig.</Typography>, {
        variant: 'error',
      })
    } else {
      enqueueSnackbar(<Typography variant="body2">Melding lagret.</Typography>, { variant: 'success' })

      onUpdateEventView(viewEvent.id)
    }

    setMessagesProps(
      messagesProps.map((messageProps) => {
        if (messageProps.platformType === platformMessage.message.platformType) {
          return {
            ...messageProps,
            platformMessage: {
              ...messageProps.platformMessage,
              template: platformMessage.message,
            },
            messageIsExternallyVisible: platformMessage.messageIsExternallyVisible,
          }
        }
        return messageProps
      }),
    )
  }

  return (
    <Stack direction={'row'} spacing={2}>
      {messagesProps.map((messageProps, index) => (
        <ExternalCommunication key={index} viewEvent={viewEvent} messageProps={messageProps} templates={platformTemplates} onChange={handleSubmit} />
      ))}
    </Stack>
  )
}
